module.exports = __webpack_public_path__ + "static/media/signage-industrial-img8.e7748a3c.jpg";